import BriefcaseIcon from "@atlaskit/icon/core/briefcase";
import CalendarIcon from "@atlaskit/icon/core/calendar";
import ChevronDownIcon from "@atlaskit/icon/core/chevron-down";
import ClockIcon from "@atlaskit/icon/core/clock";
import DevicesIcon from "@atlaskit/icon/core/devices";
import EmailIcon from "@atlaskit/icon/core/email";
import InformationCircleIcon from "@atlaskit/icon/core/information-circle";
import LinkExternalIcon from "@atlaskit/icon/core/link-external";
import LocationIcon from "@atlaskit/icon/core/location";
import OfficeBuildingIcon from "@atlaskit/icon/core/office-building";
import PersonIcon from "@atlaskit/icon/core/person";
import PersonAvatarIcon from "@atlaskit/icon/core/person-avatar";
import StarUnstarredIcon from "@atlaskit/icon/core/star-unstarred";
import SubtasksIcon from "@atlaskit/icon/core/subtasks";
import TagIcon from "@atlaskit/icon/core/tag";
import DatabaseStorageCacheIcon from "@atlaskit/icon-lab/core/database-storage-cache";
import ServiceIcon from "@atlaskit/icon-lab/core/service";
import type {NewCoreIconProps} from "@atlaskit/icon/dist/types/types";
import {
    AnankeBriefcaseIcon,
    AnankeCalendarIcon,
    AnankeChevronDownIcon,
    AnankeClockIcon,
    AnankeDatabaseStorageCacheIcon,
    AnankeDevicesIcon,
    AnankeEmailIcon,
    AnankeInformationCircleIcon,
    AnankeLinkExternalIcon,
    AnankeLocationIcon,
    AnankeModelVariantIcon,
    AnankeOfficeBuildingIcon,
    AnankePersonAvatarIcon,
    AnankePersonIcon,
    AnankeServiceIcon,
    AnankeStarUnstarredIcon,
    AnankeSubtasksIcon,
    AnankeTagIcon,
} from "~/domainModels/workspaceSpecific/icons";
import type {JSX} from "react";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {ModelVariantIcon} from "~/components/svgs";
export const eventContainerKanbanCardIconsMap: Record<Uuid, (props: NewCoreIconProps) => JSX.Element> = {
    [AnankeTagIcon]: TagIcon,
    [AnankeDevicesIcon]: DevicesIcon,
    [AnankeStarUnstarredIcon]: StarUnstarredIcon,
    [AnankeSubtasksIcon]: SubtasksIcon,
    [AnankeChevronDownIcon]: ChevronDownIcon,
    [AnankeEmailIcon]: EmailIcon,
    [AnankeCalendarIcon]: CalendarIcon,
    [AnankeBriefcaseIcon]: BriefcaseIcon,
    [AnankeOfficeBuildingIcon]: OfficeBuildingIcon,
    [AnankeInformationCircleIcon]: InformationCircleIcon,
    [AnankePersonAvatarIcon]: PersonAvatarIcon,
    [AnankeLocationIcon]: LocationIcon,
    [AnankeLinkExternalIcon]: LinkExternalIcon,
    [AnankeModelVariantIcon]: (props) => <ModelVariantIcon {...props} />,
    [AnankePersonIcon]: PersonIcon,
    [AnankeClockIcon]: ClockIcon,
    [AnankeDatabaseStorageCacheIcon]: DatabaseStorageCacheIcon,
    [AnankeServiceIcon]: ServiceIcon,
};

export const eventContainerEditPanelIconsMap: Record<Uuid, (props: NewCoreIconProps) => JSX.Element> = {
    [AnankeInformationCircleIcon]: InformationCircleIcon,
    [AnankeCalendarIcon]: CalendarIcon,
    [AnankeTagIcon]: TagIcon,
    [AnankeDevicesIcon]: DevicesIcon,
    [AnankeStarUnstarredIcon]: StarUnstarredIcon,
    [AnankeSubtasksIcon]: SubtasksIcon,
    [AnankeChevronDownIcon]: ChevronDownIcon,
    [AnankeEmailIcon]: EmailIcon,
    [AnankeBriefcaseIcon]: BriefcaseIcon,
    [AnankeOfficeBuildingIcon]: OfficeBuildingIcon,
    [AnankePersonAvatarIcon]: PersonAvatarIcon,
    [AnankePersonIcon]: PersonIcon,
    [AnankeClockIcon]: ClockIcon,
    [AnankeLinkExternalIcon]: LinkExternalIcon,
    [AnankeModelVariantIcon]: (props) => <ModelVariantIcon {...props} />,
    [AnankeLocationIcon]: LocationIcon,
};
